var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseCircleRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7854 5.29132C16.4189 4.73622 13.9561 4.73622 11.5896 5.29132C8.46451 6.02437 6.02437 8.4645 5.29132 11.5896C4.73622 13.9561 4.73622 16.4189 5.29132 18.7854C6.02437 21.9105 8.46451 24.3506 11.5896 25.0836C13.9561 25.6387 16.4189 25.6387 18.7854 25.0836C21.9105 24.3506 24.3506 21.9105 25.0836 18.7854C25.6387 16.4189 25.6387 13.9561 25.0836 11.5896C24.3506 8.46451 21.9105 6.02437 18.7854 5.29132ZM11.1614 3.46587C13.8095 2.84471 16.5655 2.84471 19.2135 3.46587C23.032 4.36155 26.0135 7.34301 26.9091 11.1614C27.5302 13.8095 27.5302 16.5655 26.9091 19.2135C26.0135 23.032 23.032 26.0135 19.2135 26.9091C16.5655 27.5302 13.8095 27.5302 11.1614 26.9091C7.34302 26.0135 4.36155 23.032 3.46587 19.2136C2.84471 16.5655 2.84471 13.8095 3.46587 11.1614C4.36155 7.34301 7.34301 4.36155 11.1614 3.46587Z",
    fill: "#FF5900"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3614 11.3619C11.8436 10.8797 12.6254 10.8797 13.1076 11.3619L15.1447 13.3991L17.1819 11.3619C17.6641 10.8797 18.4459 10.8797 18.9281 11.3619C19.4103 11.8441 19.4103 12.6258 18.9281 13.108L16.891 15.1452L18.9281 17.1825C19.4103 17.6647 19.4103 18.4463 18.9281 18.9285C18.4459 19.4107 17.6641 19.4107 17.1819 18.9285L15.1447 16.8914L13.1076 18.9285C12.6254 19.4107 11.8436 19.4107 11.3614 18.9285C10.8792 18.4463 10.8792 17.6647 11.3614 17.1825L13.3985 15.1452L11.3614 13.108C10.8792 12.6258 10.8792 11.8441 11.3614 11.3619Z",
    fill: "#FF5900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircleRed);
export default __webpack_public_path__ + "static/media/close-circle-red.13c41334604b16b367ce579b135b9e59.svg";
export { ForwardRef as ReactComponent };